export {default as path} from "./src/path";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-path/index.js
// module id = ../../../../d3-path/index.js
// module chunks = 4